<template>
  <div class="match-item" :style="{ color: settings?.main?.textColor }">
    <div v-if="status === 'live'" class="match-item__container live">
      <div class="match-item__left">
        <div class="match-item__status">
          <span>17 мин</span>
        </div>
        <div class="match-item__teams">
          <div class="match-item__team">
            <div
              class="match-item__score"
              :style="{ backgroundColor: scoreBgColor }"
            >
              {{ match.score.home }}
            </div>
            {{ match.teams.home }}
          </div>
          <div class="match-item__team">
            <div
              class="match-item__score"
              :style="{ backgroundColor: scoreBgColor }"
            >
              {{ match.score.away }}
            </div>
            {{ match.teams.away }}
          </div>
        </div>
        <div class="match-item__info">{{ `${match.halftimeScore}, ${match.note}` }}</div>
      </div>
      <div class="match-item__right">
        <div class="match-item__bet">
          <div
            class="match-item__bet-header"
            :style="{ backgroundColor: betBgColor }"
          >
            <span>П1</span>
            <span>X</span>
            <span>П2</span>
          </div>
          <div class="match-item__bet-body">
            <span
              :style="{
                backgroundColor: betBgColor,
                color: settings?.main?.iconColor,
              }"
            >
              <svg
                width="13"
                height="19"
                viewBox="0 0 13 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2.0874 18.1929C1.40706 18.1929 0.887533 18.0073 0.528809 17.6362C0.17627 17.2713 0 16.7209 0 15.9849V9.59277C0 8.86296 0.17627 8.31559 0.528809 7.95068C0.887533 7.57959 1.40706 7.39404 2.0874 7.39404H10.5762C11.2565 7.39404 11.7729 7.57959 12.1255 7.95068C12.4842 8.31559 12.6636 8.86296 12.6636 9.59277V15.9849C12.6636 16.7209 12.4842 17.2713 12.1255 17.6362C11.7729 18.0073 11.2565 18.1929 10.5762 18.1929H2.0874ZM2.13379 16.792H10.5298C10.7339 16.792 10.8885 16.7301 10.9937 16.6064C11.105 16.4889 11.1606 16.3158 11.1606 16.0869V9.49072C11.1606 9.26188 11.105 9.0887 10.9937 8.97119C10.8885 8.85368 10.7339 8.79492 10.5298 8.79492H2.13379C1.93587 8.79492 1.78125 8.85368 1.66992 8.97119C1.55859 9.0887 1.50293 9.26188 1.50293 9.49072V16.0869C1.50293 16.3158 1.55859 16.4889 1.66992 16.6064C1.78125 16.7301 1.93587 16.792 2.13379 16.792ZM1.62354 8.1084V5.17676C1.62354 4.014 1.84619 3.04915 2.2915 2.28223C2.743 1.5153 3.32747 0.943197 4.04492 0.565918C4.76237 0.188639 5.52311 0 6.32715 0C7.13737 0 7.9012 0.188639 8.61865 0.565918C9.3361 0.943197 9.91748 1.5153 10.3628 2.28223C10.8143 3.04915 11.04 4.014 11.04 5.17676V8.1084H9.57422V4.98193C9.57422 4.20264 9.42269 3.54704 9.11963 3.01514C8.82275 2.48324 8.42692 2.08122 7.93213 1.80908C7.44352 1.53695 6.90853 1.40088 6.32715 1.40088C5.75195 1.40088 5.21696 1.53695 4.72217 1.80908C4.23356 2.08122 3.84082 2.48324 3.54395 3.01514C3.24707 3.54704 3.09863 4.20264 3.09863 4.98193V8.1084H1.62354Z"
                  fill="currentColor"
                />
              </svg>
            </span>
            <span :style="{ backgroundColor: betBgColor }">2.68</span>
            <span class="disabled" :style="{ backgroundColor: betBgColor }">
              2.68
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else-if="status === 'upcoming'"
      class="match-item__container upcoming"
    >
      <div class="match-item__left">
        <div class="match-item__status">
          <span>{{ match.datetime }}</span>
        </div>
        <div class="match-item__teams">
          <div class="match-item__team">{{ match.teams.home }}</div>
          <div class="match-item__team">{{ match.teams.away }}</div>
        </div>
        <div class="match-item__info">Место проведения: {{ match.venue }}</div>
      </div>
      <div class="match-item__right">
        <div class="match-item__bet">
          <div
            class="match-item__bet-header"
            :style="{ backgroundColor: betBgColor }"
          >
            <span>П1</span>
            <span>X</span>
            <span>П2</span>
          </div>
          <div class="match-item__bet-body">
            <span
              :style="{
                backgroundColor: betBgColor,
              }"
            >
              2.68
            </span>
            <span :style="{ backgroundColor: betBgColor }">2.68</span>
            <span :style="{ backgroundColor: betBgColor }">
              2.68
            </span>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="match-item__container finished">
      <div class="match-item__left">
        <div class="match-item__status">
          <span>{{ match.datetime }}</span>
          <div class="match-item__tag" :style="{ backgroundColor: scoreBgColor }">Завершено</div>
        </div>
        <div class="match-item__teams">
          <div class="match-item__team">{{ `${match.teams.home} - ${match.teams.away}` }}</div>
        </div>
        <div class="match-item__info">Счет 1:4 (0:2)</div>
      </div>
    </div>
  </div>
</template>
<script>
import { addOpacity } from '@/services/utils/color'

export default {
  props: {
    match: { type: Object, required: true },
    settings: { type: Object, required: true },
  },
  computed: {
    status() {
      return this.match.status
    },
    betBgColor() {
      return addOpacity(this.settings?.main?.overlayColor, 0.08)
    },
    scoreBgColor() {
      return addOpacity(this.settings?.main?.overlayColor, 0.2)
    },
  },
}
</script>

<style scoped lang="scss">
.match-item {
  position: relative;
  padding: 8px;

  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;
  }

  .live {
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background-color: #fcc341;
      border-radius: 0 2px 2px 0;
    }

    .match-item__status span {
      font-weight: 700;
    }
  }

  &__left {
    display: flex;
    flex-direction: column;
  }

  &__right {
    flex-shrink: 0;
  }

  &__status {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    span {
      font-size: 7px;
      line-height: 9px;
    }
  }

  &__tag {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    padding: 2px 6px;
    font-weight: 700;
    font-size: 7px;
    line-height: 9px;
    margin-left: 4px;
  }

  &__teams {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  &__team {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 9px;
    line-height: 12px;
    font-weight: 700;
  }

  &__score {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 12px;
    border-radius: 3px;
  }

  &__info {
    font-size: 8px;
    line-height: 9px;
    margin-top: 6px;
  }

  &__bet {
    display: flex;
    flex-direction: column;
    max-width: 100px;
    text-transform: uppercase;
    border-radius: 8px;
    overflow: hidden;
  }

  &__bet-header {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    font-weight: 500;
    font-size: 7px;
    line-height: 9px;
    text-align: center;
    margin-bottom: 1px;

    span {
      padding: 2px 3px;
    }
  }

  &__bet-body {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1px;
    font-size: 9px;
    line-height: 10px;
    text-align: center;
    font-weight: 700;

    svg {
      width: 12px;
      height: 12px;
      opacity: 0.4;
    }

    span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 16px 4px;
    }

    .highlighted {
      background-color: #ffeab8 !important;
    }
  }
}
</style>
